/* ラジオボタン */
import React, { memo } from 'react';
import { InputGroup, Form } from 'react-bootstrap';
var RadioButton = function (_a) {
    var id = _a.id, class_name = _a.class_name, value = _a.value, name = _a.name, sources = _a.sources, handleChange = _a.handleChange, disabled = _a.disabled;
    return (React.createElement(InputGroup, { className: class_name }, sources.map(function (src, index) {
        return (React.createElement("label", { key: src.key },
            React.createElement(Form.Check, { id: id + "-" + index, type: "radio", inline: true, value: src.key, name: name, checked: src.key === value, onChange: handleChange, disabled: disabled, className: "radio-button" }),
            src.value));
    })));
};
export default memo(RadioButton);
